import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import { getCurrentOrgId, setCurrentOrgId } from '~/utils/local-storage';

/**
 * Keeps track of the logged-in organisation in localStorage. Whenever this tab
 * regains focus, the stored org is compared against the org this tab last knew
 * about — if they differ (e.g. the org was switched in another tab), the page
 * is reloaded so this tab picks up the new org.
 */
export function useOrgChangeReload() {
  const { user } = useAuth0();
  const orgId = user?.org_id;
  const knownOrgRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!orgId) {
      return;
    }

    setCurrentOrgId(orgId);
    knownOrgRef.current = orgId;
  }, [orgId]);

  useEffect(() => {
    function handleFocus() {
      const storedOrgId = getCurrentOrgId();

      if (knownOrgRef.current && storedOrgId && storedOrgId !== knownOrgRef.current) {
        window.location.reload();
      }
    }

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, []);
}
